import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesMetier} from '@app/core/interfaces';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import {SoinsHospitalisationTableListeRestApiService} from './soins-hospitalisation-table.liste.rest-api.service';

@Injectable({providedIn: 'root'})
export class SoinsHospitalisationTableListeMetierService implements IRecuperationListeDonneesMetier {
  @Autowired() restApi: SoinsHospitalisationTableListeRestApiService;

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    return this.restApi.requeteRecuperationListeDonnees(data, args);
  }
}
